import Head from 'next/head';

const SEO = ({ 
  title = 'BusinessWallet.eu - The Modular Digital Identity Wallet for European Businesses',
  description = 'Empower your business with BusinessWallet.eu - the secure, customizable digital wallet for managing verifiable credentials. Built for EU SMEs and enterprises, our platform offers plugin-based flexibility, eIDAS 2.0 compliance, and seamless integration with your business tools.',
  keywords = 'business management, expense tracking, financial management, business wallet, business tools',
  ogImage = '/assets/seo/og-image.jpg',
  ogUrl = 'https://businesswallet.eu',
  children 
}) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/favicon.ico" />
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
      <meta name="theme-color" content="#ffffff" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={ogUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Additional meta tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={ogUrl} />
      
      {children}
    </Head>
  );
};

export default SEO; 